import React from "react";
import "./ProjectsStyle.css";
import p1 from "../../Images/projects/test-1.jpg";

import { HiExternalLink } from "react-icons/hi";
import { HiOutlineCode } from "react-icons/hi";

import brth from "../../Images/projects/brotheon.png";
import dtwo from "../../Images/projects/dtwoinone.png";
import bagh from "../../Images/projects/bagh.png";
import crf from "../../Images/projects/crossfire-static.png";

export default function Projects() {
  return (
    <>
      <div className="project-wrapper">
        <div className="project-main">
          PROJECTS{" "}
          <a
            href="https://drive.google.com/drive/folders/1sIQEgc9Cu2AgQGwe--7t4i5mmiUCGQUr?usp=sharing"
            target="_blank"
          >
            <HiExternalLink />
          </a>{" "}
        </div>
        <div className="project-win">
          <div className="project-tile">
            <img src={brth} className="prj-img-src wobble"></img>
            <div className="prj-desc">
              <div className="prj-title">
                7Hearts
                <a
                  href="https://starmandev.itch.io/brotheon?secret=i7POxEuKa3G0ugXXzD0H9hwZ3VY"
                  target="_blank"
                >
                  <HiExternalLink />
                </a>
                <a
                  href="https://github.com/St4rman/7heartGame.git"
                  target="_blank"
                >
                  <HiOutlineCode />
                </a>
              </div>
              <div className="desc-text">
                <p>
                  Inspired from the raid encounters of MMOs, this concept slice
                  has you shooting and bombing while doding midair to evade the
                  unslaught of enemies that come your way. Aiming, weaving and
                  managing your resources allowed for a standard experience with
                  my own twist, which was fun to work on.
                </p>
                <p>
                  Implemented a state machine, a rigidbody based player movement
                  system, Srciptable Object based Weapons and A realized boss
                  encounter{" "}
                </p>
                <p className="skills">Unity | C# </p>
              </div>
            </div>
          </div>

          <div className="project-tile">
            <div className="prj-desc">
              <div className="prj-title right-force">
                D2InOne
                {/* <a href="https://github.com/Abushek/DTwoInOne.git" target="_blank"><HiOutlineCode/></a> */}
              </div>
              <div className="desc-text right-force">
                <p>
                  D2inone is a companion web-app to Bungie's live service MMMO
                  Shooter Destiny 2. It allows users to track their progress and
                  visually displays live events and data from the game and
                  features an easy to understand tabloid updated weekly
                </p>{" "}
                <p>
                  {" "}
                  This application was mainly built to aid my own personal needs
                  for the information required at my finger tips, but quickly
                  grew in scope. It is currently in development and will feature
                  a continous deploy cycle. It helps me challenge my UI/UX and
                  Full stack development skills
                </p>{" "}
                <p className="skills">
                  REACT | HTML5 | Responsive CSS | Node | Figma | Adobe
                  Photoshop
                </p>
              </div>
            </div>
            <img src={dtwo} className="prj-img-src wobble rgt"></img>
          </div>

          <div className="project-tile">
            <img src={bagh} className="prj-img-src wobble"></img>
            <div className="prj-desc">
              <div className="prj-title">
                A boy and a Ghost
                <a
                  href="https://starmandev.itch.io/a-boy-and-his-ghost"
                  target="_blank"
                >
                  <HiExternalLink />
                </a>
              </div>
              <div className="desc-text">
                <p>
                  While exploring with your sister in the lost temple, you find
                  yourself nothing but a ghost. Take control of both the
                  siblings as they make their way out of the dangerous temple,
                  as they must work together closely and use their unique
                  abilities to solve puzzles along the way.
                </p>
                <p>
                  Created for the GMTK game Jam 2021, in 48 hours alongside a
                  small team of 2 people, where I was responsibe for the
                  programming and implementation of the game{" "}
                </p>
                <p className="skills">Unity | C# </p>
              </div>
            </div>
          </div>

          <div className="project-tile">
            <div className="prj-desc">
              <div className="prj-title right-force">
                Other Projects
                <a
                  href="https://drive.google.com/file/d/1XrtsFpYLFrMp_8MlZapNh5ElFq4xMmhB/view?usp=sharing"
                  target="_blank"
                >
                  <HiExternalLink />
                </a>
              </div>
              <div className="desc-text right-force">
                 <p>Attached Google Drive Link features a video of an rpg-like game I worked on for about a month. Many more projects that I've worked on can be found <a href="https://drive.google.com/drive/folders/1sIQEgc9Cu2AgQGwe--7t4i5mmiUCGQUr?usp=sharing">here</a>. Ranges from video demonstrations of game projects and progress videos of 7Hearts. Also features some UI/UX and character design work</p>
              </div>
            </div>
            <img src={crf} className="prj-img-src wobble rgt"></img>
          </div>
        </div>
      </div>
    </>
  );
}
